import React from 'react'
import './Gwp.css';

function Gwp() {
    return (
        <div className='text-start'>
        <div className='d-flex justify-content-center mt-3'>
            <table>
        <tr>
            <th>ASHRAE #</th>
            <th>Blend Composition</th>
            <th>GWP*</th>
        </tr>
        <tr><td>R-401A</td><td>53% HCFC-22, 34% HCFC-124, 13% HFC-152a</td><td>16</td></tr>
        <tr><td>R-401B</td><td>61% HCFC-22, 28% HCFC-124, 11% HFC-152a</td><td>14</td></tr>
        <tr><td>R-401C</td><td>33% HCFC-22, 52% HCFC-124, 15% HFC-152a</td><td>19</td></tr>
        <tr><td>R-402A</td><td>38% HCFC-22, 6% HFC-125, 2% propane</td><td>2,100</td></tr>
        <tr><td>R-402B</td><td>6% HCFC-22, 38% HFC-125, 2% propane</td><td>1,330</td></tr>
        <tr><td>R-403B</td><td>56% HCFC-22, 39% PFC-218, 5% propane</td><td>3,444</td></tr>
        <tr><td>R-404A</td><td>44% HFC-125, 4% HFC-134a, 52% HFC-143a</td><td>3,922</td></tr>
        <tr><td>R-406A</td><td>55% HCFC-22, 41% HCFC-142b, 4% isobutane</td><td>0</td></tr>
        <tr><td>R-407A</td><td>20% HFC-32, 40% HFC-125, 40% HFC-134a</td><td>2,107</td></tr>
        <tr><td>R-407B</td><td>10% HFC-32, 70% HFC-125, 20% HFC-134a</td><td>2,804</td></tr>
        <tr><td>R-407C</td><td>23% HFC-32, 25% HFC-125, 52% HFC-134a</td><td>1,774</td></tr>
        <tr><td>R-407D</td><td>15% HFC-32, 15% HFC-125, 70% HFC-134a</td><td>1,627</td></tr>
        <tr><td>R-407E</td><td>25% HFC-32, 15% HFC-125, 60% HFC-134a</td><td>1,552</td></tr>
        <tr><td>R-408A</td><td>47% HCFC-22, 7% HFC-125, 46% HFC-143a</td><td>2,301</td></tr>
        <tr><td>R-409A</td><td>60% HCFC-22, 25% HCFC-124, 15% HCFC-142b</td><td>0</td></tr>
        <tr><td>R-410A</td><td>50% HFC-32, 50% HFC-125</td><td>2,088</td></tr>
        <tr><td>R-410B</td><td>45% HFC-32, 55% HFC-125</td><td>2,229</td></tr>
        <tr><td>R-411A</td><td>87.5% HCFC-22, 11% HFC-152a, 1.5% propylene</td><td>14</td></tr>
        <tr><td>R-411B</td><td>94% HCFC-22, 3% HFC-152a, 3% propylene</td><td>4</td></tr>
        <tr><td>R-413A</td><td>88% HFC-134a, 9% PFC-218, 3% isobutane</td><td>2,053</td></tr>
        <tr><td>R-500</td><td>73.8% CFC-12, 26.2% HFC-152a, 48.8% HCFC-22</td><td>32</td></tr>
        <tr><td>R-502</td><td>48.8% HCFC-22, 51.2% CFC-115</td><td>0</td></tr>
        <tr><td>R-504</td><td>48.2% HFC-32, 51.8% CFC-115</td><td>325</td></tr>
        <tr><td>R-507</td><td>5% HFC-125, 5% HFC-143a</td><td>3,985</td></tr>
        <tr><td>R-508A</td><td>39% HFC-23, 61% PFC-116</td><td>13,214</td></tr>
        <tr><td>R-508B</td><td>46% HFC-23, 54% PFC-116</td><td>13,396</td></tr>
    </table>

</div>

        </div>
    )
}

export default Gwp